import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottom-section',
  templateUrl: './bottom-section.component.html',
  styleUrls: ['./bottom-section.component.scss']
})
export class BottomSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
